<template>
	<div>
		<div class="row">
			<div class="col-md-12">
				<search-input
					ref="accountPlan"
					:alias="form.account_plan_id.alias"
					v-model="form.account_plan_id.value"
					:displayedValue="form.account_plan_name.value"
					:form="form"
					:name="'account_plan_id'"
					@search="searchAccountPlan($event)"
					:searchResult="searchAccountPlanResults.results"
					:isLoading="searchAccountPlanResults.isLoading"
					@selected="setAccountPlan($event)"
				>
					<search-input-option
						v-for="(row, index) in searchAccountPlanResults.results.data"
						:key="index"
						:index="index"
						@click="setAccountPlan(row)"
					>
						<div>
							{{ row.description }}
							<br />
							<small class="text-muted">{{ row.code }}</small>
							<br />
						</div>
					</search-input-option>
				</search-input>
			</div>
		</div>
	</div>
</template>

<script>
	import Form from "../../../mixins/Form.js";

	export default {
		props: {
			value: {},
			account_plan_name: {},
		},

		data: function () {
			return {
				form: new Form({
					account_plan_id: {
						alias: "Plano de Contas",
						validate: {
							required: true,
						},
					},

					account_plan_name: {},
				}),

				searchAccountPlanResults: {
					results: {},
					isLoading: false,
				},
			};
		},

		created() {
			this.form.account_plan_id.value = this.value;
			this.form.account_plan_name.value = this.account_plan_name;
		},

		computed: {
			account_plan_id() {
				return this.form.account_plan_id.value;
			},

			accountPlans() {
				return this.$store.state.accountPlan.accountPlans;
			},
		},

		watch: {
			account_plan_id(newValue) {
				this.$emit("input", newValue);
			},

			account_plan_name: function (newValue, oldValue) {
				this.form.account_plan_name.value = this.account_plan_name;
			},

			value: function (newValue, oldValue) {
				this.form.account_plan_id.value = newValue;
			},
		},

		methods: {
			searchAccountPlan(search) {
				this.searchAccountPlanResults.isLoading = true;

				this.$store
					.dispatch("accountPlan/getAccountsPlans", {
						page: search.page,
						description: search.text,
						status: 1,
						paginate: 30,
					})
					.then((response) => {
						this.searchAccountPlanResults.results = this.accountPlans;

						this.searchAccountPlanResults.isLoading = false;
					})
					.catch((error) => {
						console.log(error);
						this.error = error;
					});
			},



			setAccountPlan(accountPlan) {
				this.selectedAccountPlan = accountPlan;

				this.form.account_plan_id.value = accountPlan.id;

				this.form.account_plan_name.value = accountPlan.description;

				this.$emit("accountPlanSelected", accountPlan);
			},
		},
	};
</script>

<style>
</style>
